import api from '../backAxios';
const statusOK = 200;

class AccessService {
    async primeiroAcesso(rota, Codigo, cpf){
        try {
            const response = await api.get(`${rota}/${Codigo}/${cpf}`);

            return response.data;
        } catch (error) {
            throw new Error ('Dados Não conferem');
        }
    }

    async accessHierarquia(permissao, cpf){
        try {
            const response = await api.get(`/access-hierarquia/${permissao}/${cpf}`);

            return response.data;
        } catch (error) {
            return error.response.data;
        }
    }

    async checkAccess(rota, email, status, sistema){
        try {
            const response = await api.get(`${rota}/${email}?status=${status}&sistema=${sistema}`);
            if(response?.status !== statusOK){
                return false;
            }

            return response.data;
        } catch (error) {
            throw new Error ('Dados Não conferem');
        }
    }
}

export default new AccessService();
